<template>
  <va-form :id="id" v-model="model" :item="item" disable-redirect @saved="$emit('saved')">
    <va-text-input source="id"></va-text-input>
    <base-Scopes-selector editable :scopes="item && item.scopes" />
    <va-save-button color="white"></va-save-button>
  </va-form>
</template>

<script>
export default {
  props: {
    id: { type: String, default: '' },
    item: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      model: {
        id: null,
        scopes: [],
      },
      // choices: [
      //   // we can use this for scopes options
      //   { value: 'comics', text: 'Comics' },
      //   { value: 'novels', text: 'Novels' },
      // ],
    };
  },
  beforeMount() {
    this.model.scopes = [];
  },
};
</script>
